import { default as isGlobalSettingsMailbox } from 'owa-account-source-list-store/lib/utils/isGlobalSettingsMailbox';
import { logStartGreyError } from 'owa-analytics-start';
import type { MailboxInfo } from 'owa-client-types';
import { isRunningOnWorker } from 'owa-config';
import type { ReadOnlyAccountConfiguration } from '../store/schema/OwaSessionStore';
import { getAccountSettingsInternal } from '../utils/getAccountSettingsInternal';
import { makeEmptyAccountConfiguration } from '../utils/makeEmptyAccountConfiguration';

export const getAccountScopeUserSettings = (
    mailboxInfo: MailboxInfo,
    noGreyError?: boolean
): ReadOnlyAccountConfiguration => {
    const settings = getAccountSettingsInternal(mailboxInfo);
    if (!settings && !noGreyError && isRunningOnWorker()) {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError('AccountScopeUserSettingsMissing', undefined, undefined /*error*/, {
            isGlobalSettingsMailbox: isGlobalSettingsMailbox(mailboxInfo),
        });
    }
    return settings ?? makeEmptyAccountConfiguration();
};
